export default function GuidesSection() {
  const articles = [
    {
      slug: 'melhores-marcas',
      title: 'Melhores Marcas para Comprar',
      desc: 'Descubra as marcas mais populares e bem avaliadas no cssbuy spreadsheet. Seleções curadas pela comunidade brasileira.',
      tag: 'Marcas',
      img: 'https://readdy.ai/api/search-image?query=Luxury%20fashion%20brand%20logos%20and%20shopping%20bags%20arranged%20on%20marble%20counter%2C%20high%20end%20boutique%20atmosphere%2C%20soft%20glamorous%20lighting%2C%20designer%20retail%20experience%2C%20gold%20accents%20and%20premium%20packaging%2C%20champagne%20and%20cream%20tones%2C%20sophisticated%20luxury%20shopping%20photography%2C%20elegant%20retail%20display%2C%20aspirational%20lifestyle%20aesthetic&width=500&height=300&seq=gd-v2-brand&orientation=landscape',
    },
    {
      slug: 'frete-brasil',
      title: 'Frete para o Brasil: Guia Completo',
      desc: 'Entenda como funciona o envio, taxas e prazos de entrega. Dicas para economizar no frete internacional.',
      tag: 'Frete',
      img: 'https://readdy.ai/api/search-image?query=Cardboard%20shipping%20boxes%20with%20Brazil%20flag%20stickers%20and%20postal%20labels%20on%20wooden%20table%2C%20logistics%20and%20delivery%20concept%2C%20warm%20morning%20light%2C%20global%20ecommerce%20theme%2C%20packing%20tape%20and%20scissors%20nearby%2C%20international%20shipping%20preparation%20scene%2C%20organized%20package%20dispatch%20moment%2C%20small%20business%20fulfillment%20photography%2C%20earthy%20brown%20and%20green%20tones&width=500&height=300&seq=gd-v2-shipping&orientation=landscape',
    },
    {
      slug: 'cssbuy-vs-agentes',
      title: 'CSSBuy vs Outros Agentes',
      desc: 'Comparação detalhada entre CSSBuy e outros agentes de compra. Qual oferece o melhor custo-benefício?',
      tag: 'Comparação',
      img: 'https://readdy.ai/api/search-image?query=Split%20screen%20comparison%20concept%20with%20two%20laptops%20side%20by%20side%20on%20desk%20showing%20different%20ecommerce%20platforms%2C%20modern%20office%20setting%2C%20balanced%20professional%20lighting%2C%20decision%20making%20and%20research%20theme%2C%20notebook%20with%20handwritten%20comparison%20notes%2C%20analytical%20workspace%20photography%2C%20clean%20organized%20composition%2C%20neutral%20professional%20atmosphere&width=500&height=300&seq=gd-v2-agents&orientation=landscape',
    },
    {
      slug: 'tendencias-2026',
      title: 'Tendências Streetwear 2026',
      desc: 'Fique por dentro das principais tendências de streetwear para este ano. O que está bombando no cssbuy spreadsheet.',
      tag: 'Tendências',
      img: 'https://readdy.ai/api/search-image?query=Vibrant%20street%20fashion%20moodboard%20with%20magazine%20clippings%20fabric%20swatches%20and%20polaroid%20photos%20on%20cork%20board%2C%20creative%20studio%20atmosphere%2C%20fashion%20trend%20forecasting%20concept%2C%20colorful%20eclectic%20arrangement%2C%20natural%20window%20light%2C%20artistic%20fashion%20design%20workspace%2C%20trendy%20creative%20direction%20photography%2C%20warm%20creative%20chaos%20composition&width=500&height=300&seq=gd-v2-trends&orientation=landscape',
    },
    {
      slug: 'guia-tamanhos',
      title: 'Guia de Tamanhos: Como Acertar',
      desc: 'Nunca mais erre o tamanho! Aprenda a converter medidas e escolher o tamanho certo para cada tipo de produto.',
      tag: 'Tamanhos',
      img: 'https://readdy.ai/api/search-image?query=Measuring%20tape%20draped%20over%20clothing%20items%20with%20size%20chart%20visible%20on%20tablet%20screen%2C%20fashion%20fitting%20concept%2C%20bright%20tailor%20workshop%20atmosphere%2C%20dress%20form%20mannequin%20in%20background%2C%20warm%20professional%20lighting%2C%20precise%20measurement%20tools%2C%20clothing%20alteration%20studio%20photography%2C%20organized%20garment%20rack%20visible%2C%20cream%20and%20wood%20interior&width=500&height=300&seq=gd-v2-sizing&orientation=landscape',
    },
    {
      slug: 'como-economizar',
      title: 'Como Economizar nas Compras',
      desc: 'Estratégias práticas para economizar dinheiro usando o cssbuy spreadsheet. Cupons, promoções e dicas exclusivas.',
      tag: 'Economia',
      img: 'https://readdy.ai/api/search-image?query=Piggy%20bank%20surrounded%20by%20shopping%20receipts%20and%20calculator%20on%20sunlit%20desk%2C%20personal%20finance%20and%20smart%20shopping%20concept%2C%20warm%20cozy%20home%20office%20atmosphere%2C%20money%20saving%20theme%2C%20green%20plant%20adding%20life%2C%20organized%20budget%20planning%20scene%2C%20golden%20afternoon%20light%20through%20window%2C%20thoughtful%20financial%20planning%20photography%2C%20cream%20and%20sage%20tones&width=500&height=300&seq=gd-v2-save&orientation=landscape',
    },
    {
      slug: 'produtos-populares',
      title: 'Produtos Mais Comprados',
      desc: 'Os itens mais populares entre compradores brasileiros. Veja o que a comunidade está comprando agora.',
      tag: 'Populares',
      img: 'https://readdy.ai/api/search-image?query=Bestselling%20fashion%20items%20displayed%20on%20pedestal%20with%20award%20ribbon%2C%20product%20showcase%20concept%2C%20dramatic%20spotlight%20lighting%20on%20dark%20background%2C%20premium%20product%20presentation%2C%20number%20one%20badge%20visible%2C%20golden%20trophy%20nearby%2C%20winner%20showcase%20photography%2C%20elegant%20retail%20display%2C%20products%20illuminated%20dramatically%2C%20sophisticated%20competition%20aesthetic&width=500&height=300&seq=gd-v2-popular&orientation=landscape',
    },
    {
      slug: 'guia-iniciantes',
      title: 'CSSBuy para Iniciantes',
      desc: 'Nunca comprou da China? Este guia é para você. Do cadastro ao primeiro pedido, explicamos tudo passo a passo.',
      tag: 'Iniciantes',
      img: 'https://readdy.ai/api/search-image?query=Open%20laptop%20with%20beginner%20tutorial%20video%20playing%20next%20to%20notebook%20with%20handwritten%20shopping%20steps%2C%20learning%20and%20discovery%20concept%2C%20bright%20cheerful%20morning%20atmosphere%2C%20coffee%20and%20cookies%20on%20desk%2C%20welcoming%20educational%20environment%2C%20sticky%20notes%20with%20tips%20on%20monitor%2C%20friendly%20tutorial%20photography%2C%20natural%20daylight%2C%20encouraging%20and%20accessible%20vibe&width=500&height=300&seq=gd-v2-beginner&orientation=landscape',
    },
    {
      slug: 'replicas-qualidade',
      title: 'Réplicas de Qualidade: Guia',
      desc: 'Como identificar réplicas de alta qualidade. O que observar antes de comprar e como evitar produtos ruins.',
      tag: 'Qualidade',
      img: 'https://readdy.ai/api/search-image?query=Magnifying%20glass%20examining%20fabric%20texture%20and%20stitching%20details%20of%20clothing%20item%2C%20quality%20inspection%20concept%2C%20bright%20clean%20workshop%20lighting%2C%20attention%20to%20detail%20theme%2C%20artisan%20craftsmanship%20visible%2C%20precision%20inspection%20tools%20on%20workbench%2C%20quality%20control%20photography%2C%20macro%20detail%20shots%20visible%2C%20professional%20product%20examination%2C%20white%20and%20cream%20industrial%20aesthetic&width=500&height=300&seq=gd-v2-quality&orientation=landscape',
    },
  ];

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14 md:mb-20">
          <div className="flex-1">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight">
              Guias e Artigos
              <br />
              CSSBuy Spreadsheet
            </h2>
          </div>
          <div className="flex-1 max-w-md">
            <p className="text-foreground-500 text-base leading-relaxed">
              Conteúdo original e autoritativo sobre cssbuy spreadsheet. Nossos guias são escritos por especialistas em compras internacionais para ajudar você a comprar melhor.
            </p>
            <a href="/" className="inline-flex items-center gap-1.5 mt-3 text-foreground-600 hover:text-foreground-950 text-sm font-medium transition-colors duration-200">
              <i className="ri-home-line"></i>
              Voltar ao início
            </a>
          </div>
        </div>

        {/* Articles Grid - 3 columns */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {articles.map((article) => (
            <a
              key={article.slug}
              href={`/guia-de-compras#${article.slug}`}
              className="group rounded-2xl overflow-hidden flex flex-col cursor-pointer transition-transform duration-300 hover:-translate-y-1 bg-background-100"
            >
              <div className="relative overflow-hidden">
                <img
                  src={article.img}
                  alt={article.title}
                  className="w-full h-48 object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-background-50/90 text-foreground-700 text-xs font-semibold">
                    <i className="ri-bookmark-line text-xs"></i>
                    {article.tag}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6 flex flex-col flex-1">
                <h3 className="text-foreground-900 font-bold text-base md:text-lg mb-2 group-hover:text-foreground-950 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed flex-1">
                  {article.desc}
                </p>
                <span className="inline-flex items-center gap-1 mt-4 text-foreground-400 text-xs font-medium group-hover:text-foreground-700 transition-colors duration-200">
                  Ler artigo
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </a>
          ))}
        </div>

        {/* View All */}
        <div className="text-center mt-10">
          <a
            href="/guia-de-compras"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-foreground-200 text-foreground-600 hover:border-foreground-400 hover:text-foreground-950 text-sm font-medium transition-all duration-200 cursor-pointer"
          >
            Ver todos os artigos
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}